function Health() {
  return (
    <p>OK 45e140ab</p>
  );
}

export default Health;
